export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/text_animation.c98ff42.svg";